// @flow
import type {SagaIterator} from 'redux-saga';

import {select, call, putResolve} from 'redux-saga/effects';
import {getActiveChildrenProductId} from 'selectors/product/product';
import {getProduct} from 'actions/product/product';

/**
 * Fetches product only if new product page was opened
 * @param {number} id - product id
 */
export function* fetchProductForQuickCheckout(id: number): SagaIterator {
    const currentProductId = yield select(getActiveChildrenProductId);
    if (currentProductId !== id) {
        const getProductAction = yield call(getProduct, id);
        yield putResolve(getProductAction);
    }
}
